// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "assets/" + chunkId + "." + {"70":"915da2bd91adbf989077","508":"a94342cc31f1ab887a56","604":"3973089740954c0d28d0","742":"a143755a6545b302f822"}[chunkId] + ".js";
};